import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { theme } from 'styles/colors';

export function ConcussionRxTOSAndPrivacy() {
  const TOS = (
    <Link style={{ color: theme.secondary }} to="/terms-of-service">
      Terms of Service
    </Link>
  );

  const Privacy = (
    <Link style={{ color: theme.secondary }} to="/privacy-policy">
      Privacy Policy
    </Link>
  );
  return (
    <Typography.Text>
      I accept ConcussionRx {TOS} and {Privacy}.
    </Typography.Text>
  );
}
